'use client';

import { createStore } from 'zustand';
import type { UserData } from 'services/generated/auth-service/models/UserData';
import type { Address } from 'ui/types';
import type { Membership } from 'services/generated/membership-service-v2/models/Membership';
import { DeviceGeneration } from 'ui/utils/constants/maverick';

export interface UserStore {
  email: string | null;
  user: UserData | null;
  isLoggedIn: boolean;
  shippingAddress: Address | undefined;
  setEmail: (email: string) => void;
  clearEmail: () => void;
  setShippingAddress: (shippingAddress: Address) => void;
  clearShippingAddress: () => void;
  authToken: string | null;
  setAuthToken: (token: string | null) => void;
  strap: DeviceGeneration | null;
  setStrap: (strap: DeviceGeneration | null) => void;
  setUser: (user: UserData | null) => void;
  membership: Membership | null;
  setMembership: (membership: Membership | null) => void;
}

// Store initializer
export const createUserStore = (preloadedState?: Partial<UserStore>) =>
  createStore<UserStore>((set) => ({
    email: null,
    user: null,
    isLoggedIn: false,
    shippingAddress: undefined,
    authToken: null,
    strap: null,
    setEmail: (email) => set({ email }),
    clearEmail: () => set({ email: null }),
    setShippingAddress: (shippingAddress) => set({ shippingAddress }),
    clearShippingAddress: () => set({ shippingAddress: undefined }),
    setAuthToken: (token) => set({ authToken: token }),
    setUser: (user) => set({ user, isLoggedIn: Boolean(user) }),
    setStrap: (strap) => set({ strap }),
    membership: null,
    setMembership: (membership) => set({ membership }),
    ...preloadedState,
  }));
